module.exports = __webpack_public_path__ + "img/80.a8254ef8.jpg";